import { registerCondition } from 'core/forms';

const isNotOneDrive = ({ model }) => ({
  hasCondition: model.source_content_type !== 'one_drive',
  condition: null,
});

registerCondition('isNotOneDrive', isNotOneDrive);

export default isNotOneDrive;
